export enum GoodsFamily {
  ALUMINIUM = 'ALUMINIUM',
  CEMENT = 'CEMENT',
  IRONANDSTEEL = 'IRONANDSTEEL',
  ELECTRICITY = 'ELECTRICITY',
  CHEMICALS = 'CHEMICALS',
  FERTILIZERS = 'FERTILIZERS'
}

export enum ReportingPeriodBasis {
  CALENDAR_YEAR = 'CALENDAR_YEAR',
  FISCAL_YEAR = 'FISCAL_YEAR',
  DEFINED_BY_ELIGIBLE_MONITORING_AND_VERIFICATION_SCHEME = 'DEFINED_BY_ELIGIBLE_MONITORING_AND_VERIFICATION_SCHEME'
}
